/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircleMinus2 = createReactComponent("outline", "circle-minus-2", "IconCircleMinus2", [["path", { "d": "M20.475 15.029a9 9 0 1 0 -7.962 5.957", "key": "svg-0" }], ["path", { "d": "M16 19h6", "key": "svg-1" }]]);

export { IconCircleMinus2 as default };
//# sourceMappingURL=IconCircleMinus2.mjs.map
